export const ECOM_ORDERS_FQDN = 'wix.ecom.v1.order';
export const DATA_EXTENSIONS_USER_FIELDS_NAMESPACE = '_user_fields';
//# sourceMappingURL=dataExtensions.js.map